import type { AdoptionRateDetailsDto } from "@/api/types";
import type { TranslationFunction } from "@/translations";

export const getProjectPeriodLabel = (t: TranslationFunction, period: AdoptionRateDetailsDto["period"]): string => {
  switch (period) {
    case "zeroToOneMonth":
      return t("component.analytics-widget.adoption.project-period.1.label");
    case "twoToFourMonths":
      return t("component.analytics-widget.adoption.project-period.2.label");
    case "fourToSixMonths":
      return t("component.analytics-widget.adoption.project-period.3.label");
    case "sixToNineMonths":
      return t("component.analytics-widget.adoption.project-period.4.label");
    case "nineToTwelveMonths":
      return t("component.analytics-widget.adoption.project-period.5.label");
    case "twelveToEighteenMonths":
      return t("component.analytics-widget.adoption.project-period.6.label");
    case "eighteenToTwentyFourMonths":
      return t("component.analytics-widget.adoption.project-period.7.label");
    case "twoPlusYears":
      return t("component.analytics-widget.adoption.project-period.8.label");
  }
};
